import { render, staticRenderFns } from "./MessageFooterIcon.vue?vue&type=template&id=897a1a96&"
import script from "./MessageFooterIcon.vue?vue&type=script&lang=js&"
export * from "./MessageFooterIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports